import { useEffect, useState } from "react";
import swal from "sweetalert";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import { ReactComponent as ExportWhite } from "../../assets/icons/exportWhite.svg";
import { ReactComponent as InfoPrimaryIcon } from "../../assets/icons/infoPrimary.svg";
import { ReactComponent as LeftArrowIcon } from "../../assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../../assets/icons/dot.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import ColorInfoModal from "./ColorInfoModal";
import FilterModal from "./FilterModal";
import { viewReconciliation } from "./ice_mockdata";
import { getInterCompanyReconcilationDetailsApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";

export const filterOptions = [
  {
    name: "My User",
    type: "people",
    fieldType: "Custom",
    key: "68da6c4a4b78aec1ee742624",
    filterTypes: ["include", "exclude"],
  },
  {
    name: "My Tags",
    type: "tag",
    fieldType: "Custom",
    key: "68db6813d3413bfab6cfb00f",
    filterTypes: ["contains", "starts with", "does not contain"],
  },
  {
    name: "Assignee",
    type: "people",
    fieldType: "Default",
    key: "assigneeIDs",
    filterTypes: ["include", "exclude"],
  },
  {
    name: "Approver",
    type: "people",
    fieldType: "Default",
    key: "approverID",
    filterTypes: ["include", "exclude"],
  },
  {
    name: "Module",
    type: "shortText",
    fieldType: "Default",
    key: "module",
    filterTypes: ["contains", "starts with", "does not contain"],
  },
  {
    name: "Due Date",
    type: "date",
    fieldType: "Default",
    key: "dueDate",
    filterTypes: ["less than", "equal to", "greater than"],
  },
  {
    name: "Status",
    type: "shortText",
    fieldType: "Default",
    key: "status",
    filterTypes: ["contains", "starts with", "does not contain"],
  },
];

const ViewReconciliation = ({ setEliminationScreen,consolID }) => {
  console.log("viewReconciliation", viewReconciliation);
  const [parentCompanyData, setParentCompanyData] = useState(null);
  const [subsidiaryCompanyData, setSubsidiaryCompanyData] = useState(null);

  const [parentCompanyName, setParentCompanyName] = useState(null);
  const [parentCompanyTransactionsBalances, setParentCompanyTransactionsBalances] =
    useState([]);
  const [parentCompanyTableData, setParentCompanyTableData] = useState([]);

  const [subsidiaryCompanyName, setSubsidiaryCompanyName] = useState(null);
  const [subsidiaryCompanyTransactionsBalances, setSubsidiaryCompanyTransactionsBalances] =
    useState([]);
  const [subsidiaryCompanyTableData, setSubsidiaryCompanyTableData] = useState([]);

  const [colorModal, setColorModal] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);


  useEffect(() => {
         getInterCompanyReconcilationDetails();
  
    }, []);
  
    
      const  getInterCompanyReconcilationDetails = () => {
        getInterCompanyReconcilationDetailsApiHandler({
          consolID: consolID,
        })
          .then((res) => {
            if (res?.data?.success) {
              const RESP = res?.data;
              setParentCompanyData(RESP?.parentCompany ?? null)
              setSubsidiaryCompanyData(RESP?.subsidiaryCompany ?? null)
            } else {
              swal("Error", "Unable to get intercompany reconciliation", "error");
            }
          })
          .catch(() => {
            swal("Error", "Unable to populate intercompany reconciliation", "error");
          });
      };

  useEffect(() => {
    if (parentCompanyData) {
      console.log("parentCompanyData",parentCompanyData);
      
      setParentCompanyName(parentCompanyData?.title ?? null);
      setParentCompanyTransactionsBalances(
        parentCompanyData?.transactionAndBalanceList ?? [],
      );
      
      setParentCompanyTableData(parentCompanyData?.transactionAndBalanceAmounts ?? []);
    }
    if (subsidiaryCompanyData) {
      setSubsidiaryCompanyName(subsidiaryCompanyData?.title ?? null);
      setSubsidiaryCompanyTransactionsBalances(
        subsidiaryCompanyData?.transactionAndBalanceList ?? [],
      );
      setSubsidiaryCompanyTableData(subsidiaryCompanyData?.transactionAndBalanceAmounts ?? []);
    }
  }, [parentCompanyData, subsidiaryCompanyData]);

  const CloseColorModal = () => {
    setColorModal(false);
  };

  const handleFilterModalClose = () => {
    setFilterModalOpen(false);
  };

  return (
    <>
      <div className={icrCss.header}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            fontSize: "14px",
          }}
        >
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setEliminationScreen(prev => Math.max(prev - 1, 0))}
          >
            <span>
              <LeftArrowIcon height={12} style={{ marginBottom: "2px" }} onClick={() => setEliminationScreen(0)}
 />          
            </span>
            <span style={{ color: "#4D6D64", marginLeft: "10px" }}>
              Inter company elimination
            </span>
          </span>
          <span>
            <DotIcon />
          </span>
          <span
            style={{ color: "#4D6D64", cursor: "pointer" }}
            onClick={() => setEliminationScreen(1)}
          >
            View workings
          </span>
          <span>
            <DotIcon />
          </span>
          <span
            style={{ color: "#4D6D64", cursor: "pointer" }}
            onClick={() => setEliminationScreen(2)}
          >
            Perform reconciliation
          </span>
          <span>
            <DotIcon />
          </span>
          <span>View reconciliation</span>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            fontSize: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3px",
              fontSize: "14px",
              color: "#2D8861",
              cursor: "pointer",
              paddingRight: "4px",
            }}
            onClick={() => setColorModal(true)}
          >
            <InfoPrimaryIcon height={16} />
            What are these colors?
          </div>
          <FilterIcon
            style={{ cursor: "pointer" }}
            onClick={() => setFilterModalOpen(true)}
          />
          <Button
            icon={<ExportWhite height={16} />}
            btnColor={buttoncss.primary}
            label="Export"
          />
        </div>
      </div>
      <div className={icrCss.reconciliationPanelCtn}>
        <div className={ `${icrCss.reconciliationPanel} ${icrCss.reconciliationPanelHeaderPadding}`}>
          <div className={icrCss.reconciliationPanelHeader} style={{ borderBottom: "1px solid #eaeeed" }}>
            <label>In the Books of</label>
            <div>{parentCompanyName ? parentCompanyName : ""}</div>
          </div>
          <div className={icrCss.reconciliationPanelSubHeader}>
            <label>Transaction/Balances</label>
            {parentCompanyTransactionsBalances.length > 0 && (
              <div className={icrCss.reconciliationBubbleCtn}>
                {parentCompanyTransactionsBalances.map((item) => (
                  <span className={icrCss.reconciliationBubble}>{item}</span>
                ))}
              </div>
            )}
          </div>
          <div style={{ padding: "5px 10px" }}>
            <div className={icrCss.reconciliationTableCtn}>
              <table className={icrCss.reconciliationTable}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>Invoice number</th>
                    <th style={{ textAlign: "left" }}>Date</th>
                    <th style={{ textAlign: "right" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {parentCompanyTableData.length > 0 &&
                    parentCompanyTableData.map((item, index) => {
                      const entryClass =
                        item.status === "Full Match"
                          ? "matchedEntry"
                          : item.status === "Partial Match"
                            ? "partialMatchedEntry"
                            : item.status === "Partial Match 2"
                              ? "partialMatchedEntry2"
                              : "";

                      return (
                        <tr key={index} className={icrCss[entryClass] || ""}>
                          <td style={{ textAlign: "left" }}>
                            {item.invoiceNumber}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.invoiceDate}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {item.invoiceAmount}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className= { `${icrCss.reconciliationPanel} ${icrCss.reconciliationPanelHeaderPadding} `} >
          <div className={icrCss.reconciliationPanelHeader} style={{ borderBottom: "1px solid #eaeeed" }}>
            <label>In the Books of</label>
            <div>{subsidiaryCompanyName ? subsidiaryCompanyName : ""}</div>
          </div>
          <div className={icrCss.reconciliationPanelSubHeader}>
            <label>Transaction/Balances</label>
            {subsidiaryCompanyTransactionsBalances.length > 0 && (
              <div className={icrCss.reconciliationBubbleCtn}>
                {subsidiaryCompanyTransactionsBalances.map((item) => (
                  <span className={icrCss.reconciliationBubble}>{item}</span>
                ))}
              </div>
            )}
          </div>
          <div style={{ padding: "5px 10px" }}>
            <div className={icrCss.reconciliationTableCtn}>
              <table className={icrCss.reconciliationTable}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>Invoice number</th>
                    <th style={{ textAlign: "left" }}>Date</th>
                    <th style={{ textAlign: "right" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {subsidiaryCompanyTableData.length > 0 &&
                    subsidiaryCompanyTableData.map((item, index) => {
                      const entryClass =
                        item.status === "Full Match"
                          ? "matchedEntry"
                          : item.status === "Partial Match"
                            ? "partialMatchedEntry"
                            : item.status === "Partial Match 2"
                              ? "partialMatchedEntry2"
                              : "";

                      return (
                        <tr key={index} className={icrCss[entryClass] || ""}>
                          <td style={{ textAlign: "left" }}>
                            {item.invoiceNumber}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.invoiceDate}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {item.invoiceAmount}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {colorModal && <ColorInfoModal handleClose={CloseColorModal} />}

      {filterModalOpen && (
        <FilterModal
          filterAttr={filterOptions}
          handleClose={handleFilterModalClose}
        />
      )}
    </>
  );
};

export default ViewReconciliation;
